module.exports = __webpack_public_path__ + "img/manga-warrior.a79675e7.jpg";